var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('y-view',{attrs:{"loading":_vm.isLoading}},[_c('k-table',{attrs:{"data":_vm.logsList,"height":"calc(100vh - 40px)","rightFixedNumber":1,"columns":_vm.initColumns()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }